module.exports = __webpack_public_path__ + "img/img-4.5015b690.jpg";